import type { BookPortalAppEnv } from './bookPortalUrl'
import { LUCIMARK_FEEDS_API_PUBLIC_ORIGIN } from '../constants/feedsApi'

/** RSS directory worker origin for the given deploy tier (override wins when set). */
export function resolveFeedsApiOrigin(
  appEnv: BookPortalAppEnv,
  originOverride?: string
): string {
  const trimmed = originOverride?.trim()
  if (trimmed) {
    return trimmed.replace(/\/+$/, '')
  }
  switch (appEnv) {
    case 'staging':
      return 'https://feeds.staging.lucimark.com'
    case 'production':
      return LUCIMARK_FEEDS_API_PUBLIC_ORIGIN
    case 'development':
      return LUCIMARK_FEEDS_API_PUBLIC_ORIGIN
  }
}
